import * as _ from 'lodash';
import { __ } from '../core/utils';

export const attachmentCategoryOptions = (file_ext) => {
  const categories = [
    { label: __('products.flyout.files.thumbnail'), value: 'thumbnail' },
    { label: __('products.flyout.files.product'), value: 'product' },
    { label: __('products.flyout.files.drawing'), value: 'drawing' },
    { label: __('products.flyout.files.ambient'), value: 'ambient' },
    { label: __('products.flyout.files.technical'), value: 'technical' },
    {
      label: __('products.flyout.files.tileable-texture-for-3d'),
      value: 'tileable',
    },
    { label: __('products.flyout.files.manuals'), value: 'manuals' },
    { label: __('products.flyout.files.datasheets'), value: 'datasheets' },
    { label: __('products.flyout.files.guarantee'), value: 'guarantee' },
    {
      label: __('products.flyout.files.certificates'),
      value: 'certificates',
    },
    { label: __('products.flyout.files.catalogs'), value: 'catalogs' },
    {
      label: __('products.flyout.files.installation'),
      value: 'installation',
    },
    { label: __('products.flyout.files.bim'), value: 'bim' },
    { label: __('products.flyout.files.3d'), value: '3d' },
    { label: __('products.flyout.files.cad'), value: 'cad' },
    { label: __('products.flyout.files.2d'), value: '2d' },
    {
      label: __('products.flyout.files.photometrical-distribution'),
      value: 'light_data',
    },
    { label: __('products.flyout.files.video'), value: 'video' },
    { label: __('products.flyout.files.audio'), value: 'audio' },
    { label: __('products.flyout.files.other'), value: 'other' },
  ];

  if (_.includes(['jpg', 'jpeg', 'png'], _.toLower(file_ext))) {
    return categories;
  }

  return _.reject(categories, ({ value }) =>
    _.includes(
      ['thumbnail', 'product', 'drawing', 'ambient', 'technical', 'tileable'],
      value,
    ),
  );
};
